import { Typography } from 'components'

import { type LinkCardInterface, links } from './constants'
import * as S from './styles'

export const Links = () => {
  const Card = ({ title, description, link, image }: LinkCardInterface) => {
    return (
      <S.CardItem href={link} target="_blank">
        <S.CardImage src={image} />
        <S.CardTexts>
          <Typography design="hav-default-04-text">
            <strong>{title}</strong>
          </Typography>
          <Typography design="hav-default-04-text">{description}</Typography>
        </S.CardTexts>
      </S.CardItem>
    )
  }

  return (
    <S.Wrapper>
      <Typography design="hav-h5-text">Links úteis</Typography>
      <S.CardGrid>
        {links.map((link) => (
          <Card key={link.title} {...link} />
        ))}
      </S.CardGrid>
    </S.Wrapper>
  )
}
